import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import PublicHeader from "../components/PublicHeader";
import PublicFooter from "../components/PublicFooter";

export default function About() {
  const [page, setPage] = useState(null);
  useEffect(() => { api.get("/pages/about").then((r) => setPage(r.data)).catch(() => setPage(false)); }, []);

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <PublicHeader />
      <section className="relative bg-slate-900 py-24" data-testid="about-hero">
        {page?.featured_image && (
          <>
            <div className="absolute inset-0" style={{ backgroundImage: `url(${page.featured_image})`, backgroundSize: "cover", backgroundPosition: "center" }} />
            <div className="absolute inset-0" style={{ background: "linear-gradient(to right, rgba(15,23,42,0.94), rgba(15,23,42,0.75))" }} />
          </>
        )}
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight text-white max-w-3xl">{page?.hero_title || "About Us"}</h1>
          {page?.hero_subtitle && <p className="text-lg text-slate-200 mt-5 max-w-2xl leading-relaxed">{page.hero_subtitle}</p>}
        </div>
      </section>

      <section className="py-16 lg:py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          {page === false && <p className="text-slate-500">Content coming soon.</p>}
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-10" data-testid="about-blocks">
            {(page?.blocks || []).map((b, i) => (
              <div key={i}>
                <h2 className="font-display text-xl font-bold text-slate-900">{b.heading}</h2>
                <p className="text-slate-600 mt-3 leading-relaxed">{b.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-blue-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <h2 className="font-display text-3xl font-extrabold text-white">Start practicing today</h2>
          <p className="text-blue-100 mt-3">Create a free demo account and explore the platform.</p>
          <Link to="/register" className="inline-block mt-6"><Button data-testid="about-cta" className="h-12 px-8 bg-white text-blue-700 hover:bg-blue-50 font-semibold gap-2">Get started <ArrowRight className="h-4 w-4" /></Button></Link>
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
